/**
 * SEO Utility Functions
 * Updates canonical tags, title, and meta descriptions dynamically per page
 */

const BASE_URL = 'https://morningsandeyteer.com';

/**
 * Update canonical tag for the current page
 * @param {string} path - The page path (e.g., '/previous-results')
 */
export const updateCanonical = (path = '/') => {
  // Remove trailing slash except for homepage
  const cleanPath = path === '/' ? '/' : path.replace(/\/$/, '');
  const canonicalUrl = `${BASE_URL}${cleanPath}`;
  
  // Update or create canonical tag
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', canonicalUrl);
};

/**
 * Update page title
 * @param {string} title - The page title
 */
export const updateTitle = (title) => {
  document.title = title;
};

/**
 * Update meta description
 * @param {string} description - The meta description
 */
export const updateMetaDescription = (description) => {
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', 'description');
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', description);
};

/**
 * Update OG URL
 * @param {string} path - The page path
 */
export const updateOgUrl = (path = '/') => {
  const cleanPath = path === '/' ? '/' : path.replace(/\/$/, '');
  const url = `${BASE_URL}${cleanPath}`;
  
  let ogUrl = document.querySelector('meta[property="og:url"]');
  if (!ogUrl) {
    ogUrl = document.createElement('meta');
    ogUrl.setAttribute('property', 'og:url');
    document.head.appendChild(ogUrl);
  }
  ogUrl.setAttribute('content', url);
};

/**
 * Update robots meta tag
 * @param {string} content - Robots directive (e.g., 'index, follow' or 'noindex, nofollow')
 */
export const updateRobotsMeta = (content = 'index, follow') => {
  let robots = document.querySelector('meta[name="robots"]');
  if (!robots) {
    robots = document.createElement('meta');
    robots.setAttribute('name', 'robots');
    document.head.appendChild(robots);
  }
  robots.setAttribute('content', content);
};

/**
 * Complete SEO update for a page
 * @param {Object} config - SEO configuration
 * @param {string} config.path - Page path
 * @param {string} config.title - Page title
 * @param {string} config.description - Page description
 * @param {string} config.robots - Robots meta content (default: 'index, follow')
 */
export const updatePageSEO = ({ path, title, description, robots = 'index, follow' }) => {
  updateCanonical(path);
  updateTitle(title);
  updateMetaDescription(description);
  updateOgUrl(path);
  updateRobotsMeta(robots);
};
